export enum MapType {
  Unknown = 0,
  City = 1,
  Province = 2,
  Country = 3,
}
